define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/attributes/codeView.tmpl");
    var CodePropertiesView = require("manager-views/data-sources/attributes/CodePropertiesView");
    var Button = require("ui/button/Button");

    var CodeView = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        CodeView = Marionette.ItemView.extend({

            template:template,
            className:'data-source-code-view-container',

            ui:{
                "listContainer": ".list-container",
                "snippetCode": ".code-snippet"
            },


            uiComponents:{
                listView: {
                    type: CodePropertiesView,
                    options: {
                        el: "view.ui.listContainer",
                        collection: "view.getPropertiesCollection"
                    }
                }
            },

            //--------------------------------------------------
            // initialize
            //--------------------------------------------------

            initialize : function (options) {
                LEManager.logger.debug("CodeView:initialize");
                this.model = options.model;
            },

            onRender: function(){
                LEManager.logger.debug("CodeView:onRender");
                this.loadSnippet(_.bind(this.onSnippetLoaded, this));
            },

            //-----------------------------------------------------

            getPropertiesCollection: function(){
                LEManager.logger.debug("CodeView:getPropertiesCollection");
                return this.model.getPropertiesCollection();
            },

            getModel: function(){
                LEManager.logger.debug("CodeView:getModel");
                return this.model;
            },

            loadSnippet: function(callback){
                LEManager.logger.debug("CodeView:loadSnippet");
                var logicalName = this.model.getLogicalName();
                LEManager.logger.debug("CodeView:loadSnippet - before requiring " + logicalName + ".snippet");

                require(['!raw-loader!manager-assets/snippets/' + logicalName + ".snippet"], function (snippet) {
                    LEManager.logger.debug("CodeView:loadSnippet - snippet successfully loaded");
                    if(_.isFunction(callback)) {
                        callback(snippet);
                    }
                });
            },

            onSnippetLoaded: function(code){
                LEManager.logger.debug("CodeView:onSnippetLoaded");
                this.ui.snippetCode.html(code);
            },

            onClose: function(){
                LEManager.logger.debug("CodeView:onClose");
            }

        });
    });

    return CodeView;
});
